import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

const getAgreementState = (state: AppState) => state.settingState;

export const getSetting = createSelector(getAgreementState, state => {
	return state.setting;
});
